// extracted by css-extract-rspack-plugin
export default {"scrollable":"eBSeD","descriptionLabel":"qVrue"};